import {FETCH_ACTIVE_STUDENT_TYPES, FETCH_CURRENT_STUDENT_TYPE} from '../constants/student-type';

export function fetchActiveStudentTypes() {
  return ({
    type: FETCH_ACTIVE_STUDENT_TYPES,
    api: true,
    payload: {
      method: 'GET',
      url: '/students/student-types',
      params: {'status': true}
    }
  });
}

export function fetchCurrentStudentType() {
  return ({
    type: FETCH_CURRENT_STUDENT_TYPE,
    api: true,
    payload: {
      method: 'GET',
      url: '/students/types/type'
    }
  });
}
